import React from 'react';

type CurrencyIconProps = {
	className?: string;
	title?: string;
};

export const CandoIcon: React.FC<CurrencyIconProps> = ({
	className = 'h-5 w-5 lg:h-9 lg:w-9 object-contain overflow-visible',
	title,
}) => (
	<img src={require('../../assets/ui/coin.png')} alt={title} title={title} className={className} />
);

export const GoldenHorseshoeIcon: React.FC<CurrencyIconProps> = ({
	className = 'h-5 w-5 lg:h-10 lg:w-10 object-contain overflow-visible',
	title,
}) => (
	<img
		src={require('../../assets/ui/golden-shoe.png')}
		alt={title}
		title={title}
		className={className}
	/>
);

/** @deprecated Use CandoIcon */
export const SilverCoinIcon = CandoIcon;
